import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"][disableWheelScroll]',
})
export class DisableWheelScrollDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    event.preventDefault();
  }
}
